import styled from '@eduzz/houston-styles';

import { errorStyles } from '../styles';

export const ChildOfferItem = styled.div<{ error: number }>`
  position: relative;
  ${({ error }) => errorStyles(error, true)}
`;

export const OfferItem = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
`;

export const CenterIconOffer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;

  & label {
    margin-top: 25%;
  }
`;
